import { Avatar, Group, Loader, SimpleGrid, Text } from '@mantine/core';
import { IconAt, IconLanguage } from '@tabler/icons-react';
import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import classes from './Detail.module.css';
import useUserDetail from './useUserDetail';
import StatsCard from './components/StatsCard';
import LoadingErrorContainer from '../../../components/placeholders/LoadingErrorContainer';

function UserInfoIcons() {

    const { data, isPending, isError, isRefetching } = useUserDetail();
    console.log({
        data, isPending, isError
    });

    const statusCardsData = useMemo(() => [
        { label: 'Agency code', stats: data?.agency_code },
        { label: 'Created At', stats: data?.created_at, progress: 72, color: 'blue', icon: 'up' },
        {
            label: 'MATCHES 1 VS 1',
            stats: data?.total_1v1_match,
            progress: 52,
            color: 'red',
            icon: 'down',
        },

        {
            label: 'MATCHES 2 vs 2',
            stats: data?.total_2v2_match,
            progress: 52,
            color: 'red',
            icon: 'down',
        },
        {
            label: 'Onesignal subscribe Id',
            stats: data?.player_id ?? 'N/A',
            progress: 52,
            color: 'red',
            icon: 'down',
        },
    ], [data])
    return (

        <LoadingErrorContainer isError={isError} isLoading={isPending} isRefetching={isRefetching}>
            {
                <Group wrap="nowrap" mb={"md"}>
                    <Avatar
                        src={data?.image?.url}
                        size={94}
                        radius="md"
                    />
                    <div>
                        <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
                            {data?.country}
                        </Text>

                        <Text fz="lg" fw={500} className={classes.name}>
                            {data?.tiktok_username}    </Text>

                        <Group wrap="nowrap" gap={10} mt={3}>
                            <IconAt stroke={1.5} size="1rem" className={classes.icon} />
                            <Text fz="xs" c="dimmed">
                                {data?.email}
                            </Text>
                        </Group>

                        <Group wrap="nowrap" gap={10} mt={5}>
                            <IconLanguage stroke={1.5} size="1rem" className={classes.icon} />
                            <Text fz="xs" c="dimmed">
                                {data?.lang}
                            </Text>
                        </Group>
                    </div>
                </Group>
            }
            <SimpleGrid cols={{ base: 1, sm: 5 }}>{statusCardsData.map((stat) => <StatsCard
                stat={stat}
            />)}</SimpleGrid>;


        </LoadingErrorContainer>
    );
}
export default UserInfoIcons;
